import { createApp } from 'vue'
const files: Record<string, any> = import.meta.glob('./**/*.ts', { eager: true })
/**
 * @description 加载所有 Plugins
 * @param  {ReturnType<typeof createApp>} app 整个应用的实例
 */
export const registerPlugins = (app: ReturnType<typeof createApp>) => {
  for (const key in files) {
    files[key].default?.(app)
  }
}
